// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectGroupAccessRightOverlayController_wrapper__60BZ3"};